module.exports = __webpack_public_path__ + "img/UDYOG ADHAAR.fa450319.png";